import { createPortal } from 'react-dom';
import { useEffect } from 'react';

const BACKDROP_STYLE: React.CSSProperties = {
  position: 'fixed',
  zIndex: 520,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'block',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

const ACTIVE_MODAL_Z_INDEX = '521';

export interface GModalOverlayBackdropProps {
  /** Controls visibility of the backdrop */
  isOpen: boolean;
  /** Class name inside the modal that should be raised above the backdrop */
  activeModalClass: string;
}

export const GModalOverlayBackdrop: React.FC<GModalOverlayBackdropProps> = ({
  isOpen,
  activeModalClass,
}) => {
  useEffect(() => {
    if (!isOpen || !activeModalClass) return;

    // Find the modal container that contains the active modal class and raise its z-index
    const activeModalContainer = document.querySelector(
      `.Polaris-Modal-Dialog__Container:has(.${activeModalClass})`,
    ) as HTMLElement | null;

    if (activeModalContainer) {
      activeModalContainer.style.zIndex = ACTIVE_MODAL_Z_INDEX;
    }

    return () => {
      // Reset z-index when backdrop closes
      if (activeModalContainer) {
        activeModalContainer.style.zIndex = '';
      }
    };
  }, [isOpen, activeModalClass]);

  if (!isOpen) return null;

  return createPortal(<div style={BACKDROP_STYLE} />, document.body);
};
